module.exports = __webpack_public_path__ + "img/115.c807ba0a.jpg";